var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _circle, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataLoad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 200C155.228 200 200 155.228 200 100C200 44.7715 155.228 0 100 0C44.7715 0 0 44.7715 0 100C0 155.228 44.7715 200 100 200Z",
    fill: "#B9D4E9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.3379,
    y: 103.572,
    width: 25.9646,
    height: 38.9466,
    rx: 5,
    fill: "white",
    stroke: "#015294",
    strokeWidth: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 106.607,
    y: 94.626,
    width: 25.9646,
    height: 47.8922,
    rx: 5,
    fill: "white",
    stroke: "#015294",
    strokeWidth: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64.4727,
    y: 76.3447,
    width: 25.9646,
    height: 66.1732,
    rx: 5,
    fill: "white",
    stroke: "#015294",
    strokeWidth: 6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64.4727,
    y: 95.9751,
    width: 25.9646,
    height: 44.73,
    rx: 1,
    fill: "#015294"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 106.607,
    y: 114.452,
    width: 25.9646,
    height: 26.2534,
    rx: 1,
    fill: "#015294"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22.3379,
    y: 118.572,
    width: 25.9646,
    height: 22.1328,
    rx: 1,
    fill: "#015294"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 148.743,
    y: 67.1611,
    width: 25.9646,
    height: 75.3569,
    rx: 5,
    fill: "white",
    stroke: "#015294",
    strokeWidth: 6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 148.743,
    y: 90.4858,
    width: 25.9646,
    height: 50.2192,
    fill: "#015294"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.607 40.1516L120.077 73.3353L77.9181 50.8373L37.2381 76.5015L33.8271 72.3571L77.4829 44.2439L119.444 66.6185L159.969 36.2053L163.607 40.1516Z",
    fill: "#015294"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119.59,
    cy: 67.1611,
    r: 7.5,
    fill: "white",
    stroke: "#015294",
    strokeWidth: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.726,
    cy: 40.6392,
    r: 7.5,
    fill: "white",
    stroke: "#015294",
    strokeWidth: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.4551,
    cy: 49.6392,
    r: 7.5,
    fill: "white",
    stroke: "#015294",
    strokeWidth: 5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.3203,
    cy: 73.3984,
    r: 7.5,
    fill: "white",
    stroke: "#015294",
    strokeWidth: 5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataLoad);
export default __webpack_public_path__ + "static/media/Data-load.d57518354b48bd2fcd0c91d0bb51596e.svg";
export { ForwardRef as ReactComponent };